module.exports = __webpack_public_path__ + "static/media/smile-wink.ba84b40f.svg";